import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-logo-brivia',
  templateUrl: './logo-brivia.component.html',
  styleUrls: ['./logo-brivia.component.scss'],
})
export class LogoBriviaComponent {

  @Input() width: number;
  @Input() height: number;
}
